import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { JSX, ReactElement } from 'react';

interface TOCEntryProps {
  readonly label: JSX.Element | string;
  readonly summary: JSX.Element | string;
  readonly icon: ReactElement | null;
}

const TOCEntry = ({ label, summary, icon }: TOCEntryProps): JSX.Element => {
  return (
    <div className="flex gap-2 md:flex-col">
      <div className="grow-0">{icon}</div>
      <div>
        <Typography color="inherit" variant="h6" weight="normal" Element="h2">
          {label}
        </Typography>
        <Typography color="inherit" className="mt-2">
          {summary}
        </Typography>
      </div>
    </div>
  );
};

export default TOCEntry;
